import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  miniHeader: {
    textTransform: "uppercase",
    color: blueGrey[500],
    padding: spacing(1, 3),
    borderBottom: `1px solid ${blueGrey[100]}`
  }
}))
